import { createPinia } from "pinia";
import { createApp } from "vue";
import AppComponent from "./app.vue";
import router from "./src/router";
import naive from "./src/plugins/naive-ui";
import VueToast from "vue-toast-notification";

const app = createApp(AppComponent);
const pinia = createPinia();
app
  .use(pinia)
  .use(router)
  .use(naive)
  .use(VueToast)
  .mount("#app");
